// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2URLm","footer":"ModalUpdate_footer__2wY5h"};